import { ref, defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import MessageDrawer from "./drawer.vue";
import { handleDrawerList } from "./index";
export default defineComponent({
    components: {
        MessageDrawer: MessageDrawer
    },
    props: {
        badge: {
            type: Number,
            default: 0
        },
        data: {
            type: definePropType(Array),
            required: true
        }
    },
    setup: function setup(props) {
        var drawerVisible = ref(false);
        var handleViewAll = function() {
            handleDrawerList(props.data);
            drawerVisible.value = true;
        };
        return {
            drawerVisible: drawerVisible,
            handleViewAll: handleViewAll
        };
    }
});
